import { defineMessages } from 'react-intl-next';

export const messages: {
    suggested_filter: {
        id: string;
        defaultMessage: string;
        description: string;
    };
    apply_suggested_filter: {
        id: string;
        defaultMessage: string;
        description: string;
    };
    suggested_filter_icon_label: {
        id: string;
        defaultMessage: string;
        description: string;
    };
    project: {
        id: string;
        defaultMessage: string;
        description: string;
    };
    assignee: {
        id: string;
        defaultMessage: string;
        description: string;
    };
    app: {
        id: string;
        defaultMessage: string;
        description: string;
    };
} = defineMessages({
	suggested_filter: {
		id: 'searchDialog.suggested.filter',
		defaultMessage: 'Suggested filter',
		description: 'Label for suggested filter',
	},
	apply_suggested_filter: {
		id: 'searchDialog.apply.suggested.filter',
		defaultMessage: 'Apply filter',
		description: 'Label for hover on suggested filter',
	},
	suggested_filter_icon_label: {
		id: 'searchDialog.suggestedFilter.icon.label',
		defaultMessage: 'Suggestion search',
		description: 'Assistive label for Suggestion search queries',
	},
	// filter name messages
	project: {
		id: 'searchDialog.suggestedFilter.filterName.project',
		defaultMessage: 'project',
		description: 'Label for "Project" filter name',
	},
	assignee: {
		id: 'searchDialog.suggestedFilter.filterName.assignee',
		defaultMessage: 'assignee',
		description: 'Label for "Assignee" filter name',
	},
	app: {
		id: 'searchDialog.suggestedFilter.filterName.product',
		defaultMessage: 'app',
		description: 'Label for "Product" filter name',
	},
});
